'use client';

import { useElementSticky } from '@instamenu/react-hooks';
import { useUIStateContext } from '../ui-state-context/ui-state-context';
import { stickyHeader } from './styled-nav-box.css';
import { Box, Columns } from '@instamenu/ui-system-next';
import { themeVars } from '@instamenu/ui-vanilla-extract';

export const StyledNavBox = (props: React.ComponentPropsWithRef<'div'>) => {
  const { hideHeaderRef } = useUIStateContext();
  const isSticky = useElementSticky(hideHeaderRef);

  return (
    <Box
      ref={hideHeaderRef}
      className={stickyHeader}
      style={{
        borderBottom: isSticky ? themeVars.border.default : 'none',
      }}
    >
      <Columns as="nav" {...props} />
    </Box>
  );
};
